export const getMessages = (state) => state.generic.messages.list
